import {
  CLEAR_REPORT_FILE_API_STATUS,
  FETCH_BATCH_LIST_FOR_REPORT,
  FETCH_PARAMETER_LIST,
  FETCH_REPORT_DETAILS_FOR_EDIT,
  FETCH_REPORT_FILE,
  FETCH_REPORTS_LIST,
  GENERATE_REPORT,
  RESET_GENERATE_REPORT,
} from "./types";
import { initialState } from "./initialState";
import { errorMessage } from "../../constants/responseMessages";
import reportsService from "../../services/reportsService";

export const fetchReportsList = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_REPORTS_LIST,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  try {
    const response = await reportsService.fetchReportsList(requestData);
    dispatch({
      type: FETCH_REPORTS_LIST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_REPORTS_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const generateReport = (requestData) => async (dispatch) => {
  dispatch({
    type: GENERATE_REPORT,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  try {
    const response = await reportsService.generateReport(requestData);
    dispatch({
      type: GENERATE_REPORT,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response?.data?.data,
      },
    });
  } catch (error) {
    dispatch({
      type: GENERATE_REPORT,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  } finally {
    // Always dispatch final state, success or not
    dispatch({
      type: GENERATE_REPORT,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: [], // fallback if no response
        apiSuccess: true,
      },
    });
  }
};

export const resetGenerateReport = () => ({
  type: RESET_GENERATE_REPORT,
});

export const clearParameterListState = () => ({
  type: FETCH_PARAMETER_LIST,
  payload: { ...initialState?.apiStatus },
});

export const getParametersList = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_PARAMETER_LIST,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  try {
    const response = await reportsService.getParametersList(requestData);
    dispatch({
      type: FETCH_PARAMETER_LIST,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_PARAMETER_LIST,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};

export const clearBatchListForReportState = () => ({
  type: FETCH_BATCH_LIST_FOR_REPORT,
  payload: { ...initialState?.apiStatus },
});

export const fetchFilteredBatchListForReport =
  (payload) => async (dispatch) => {
    dispatch({
      type: FETCH_BATCH_LIST_FOR_REPORT,
      payload: { ...initialState?.apiStatus, loader: true },
    });

    try {
      const response =
        await reportsService.fetchFilteredBatchListForReport(payload);
      dispatch({
        type: FETCH_BATCH_LIST_FOR_REPORT,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          data: response, // assumes response has `data`
        },
      });
    } catch (error) {
      dispatch({
        type: FETCH_BATCH_LIST_FOR_REPORT,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          message: errorMessage(error),
          apiError: true,
        },
      });
    }
  };

// export const fetchReportFile = (reqData) => async (dispatch) => {
//   dispatch({
//     type: FETCH_REPORT_FILE,
//     payload: { ...initialState?.apiStatus, loader: true },
//   });
//   try {
//     const response = await reportsService.fetchReportFile(reqData);
//     dispatch({
//       type: FETCH_REPORT_FILE,
//       payload: {
//         ...initialState?.apiStatus,
//         loader: false,
//         data: response,
//         apiError: false,
//         apiSuccess: true,
//       },
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_REPORT_FILE,
//       payload: {
//         ...initialState.apiStatus,
//         loader: false,
//         message: errorMessage(error),
//         apiError: true,
//         apiSuccess: false,
//       },
//     });
//   }
// };

export const clearReportFileState = () => ({
  type: CLEAR_REPORT_FILE_API_STATUS,
  payload: { ...initialState?.apiStatus },
});

export const fetchReportById = (payload) => async (dispatch) => {
  dispatch({
    type: FETCH_REPORT_DETAILS_FOR_EDIT,
    payload: { ...initialState?.apiStatus, loader: true },
  });
  try {
    const response = await reportsService.fetchReportById(payload);
    dispatch({
      type: FETCH_REPORT_DETAILS_FOR_EDIT,
      payload: {
        ...initialState?.apiStatus,
        loader: false,
        data: response.payload_data,
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_REPORT_DETAILS_FOR_EDIT,
      payload: {
        ...initialState.apiStatus,
        loader: false,
        message: errorMessage(error),
        apiError: true,
      },
    });
  }
};
